import _to from './to';
import type { Types } from './types';

export class InfoMentorMap {
  static to = _to;
}

export { Types as InfoMentorTypes };